const formHelper = {
    getAntiforgeryToken() {
        return document.querySelector(
            "input[name='__RequestVerificationToken']"
        ).value;
    }
};

export default formHelper;
